import React, { useState } from 'react';
import PackageSettingsCard from './PackageSettingsCard';

const SelectablePackageCard = ({ package: pkg, onSelect, isSelected = false, onPackageUpdate }) => {
  // Инициализируем выбранные регионы из данных пакета, если они есть
  const [selectedRegions, setSelectedRegions] = useState(pkg.selectedRegions || []);
  // Инициализируем limit из данных пакета, если они есть, иначе 100
  const [limit, setLimit] = useState(pkg.limit !== undefined ? pkg.limit : 100);
  // Инициализируем noWeekend из данных пакета, если они есть, иначе false
  const [noWeekend, setNoWeekend] = useState(pkg.noWeekend !== undefined ? pkg.noWeekend : false);
  console.log("pkg: ", pkg)
  return (
    <div
      className={`selectable-package-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(pkg)}
    >
      <div className="package-card-header">
        <div className="package-info-grid">
          <div className="package-name-cell">
            <h3>{pkg.paks_name}</h3>
          </div>
          <div className="package-descr-cell">
            <p>{pkg.descr || "нет данных описания"}</p>
          </div>
          <div className="package-price-cell">
            <div className="price-main">
              <span className="price-value">от {(pkg.price ? pkg.price : 1000)} ₽</span>
            </div>
            <span className="price-per-lead">/ за идентификацию</span>
          </div>
        </div>
      </div>

      {isSelected && (
        <PackageSettingsCard
          pkg={pkg}
          selectedRegions={selectedRegions}
          onRegionsChange={(regions) => {
            setSelectedRegions(regions);
            onPackageUpdate({ ...pkg, selectedRegions: regions, limit, noWeekend });
          }}
          limit={limit}
          onLimitChange={(newLimit) => {
            setLimit(newLimit);
            onPackageUpdate({ ...pkg, selectedRegions, limit: newLimit, noWeekend });
          }}
          noWeekend={noWeekend}
          onNoWeekendChange={() => {
            const newValue = !noWeekend;
            setNoWeekend(newValue);
            onPackageUpdate({ ...pkg, selectedRegions, limit, noWeekend: newValue });
          }}
        />
      )}
    </div>
  );
};

export default SelectablePackageCard;